<template>
  <div v-if="can('edit-setting')">
    <h2>Edit Setting</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-group my-4">
            <label for="title">Key</label>
            <input
              type="text"
              v-model="form.key"
              class="form-control"
              disabled
            />
          </div>
          <ValidationProvider name="title" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Title<Astrik /></label>
              <input
                type="text"
                v-model="form.title"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider name="value" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="value">Value<Astrik /></label>
              <input
                type="text"
                v-model="form.value"
                class="form-control"
                id="value"
                v-if="form.input_type == 'text'"
              />
              <select class="form-select" v-model="form.value" v-else>
                <option
                  :value="option.split(',')[0]"
                  v-for="(option, index) in form.options.split(',')"
                  :key="index"
                >
                  {{ option.split(",")[1] || option.split(",")[0] }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider name="sort" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="sort">Sort<Astrik /></label>
              <input
                type="text"
                v-model="form.sort"
                class="form-control"
                id="sort"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="status"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Status<Astrik /></label>
              <select class="form-select" v-model="form.status">
                <option
                  :value="status.value"
                  v-for="(status, index) in $store.state.status"
                  :key="index"
                >
                  {{ status.label }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Submit</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'SettingList',
              }"
            >
              Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditService",
  data() {
    return {
      form: [],
    };
  },
  mounted() {
    // if (this.can("edit-setting")) {
    this.getSettingDetail();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    getSettingDetail() {
      this.$http
        .get("setting/" + this.$route.params.id + "/edit")
        .then((res) => {
          if (res.data.status == 1) {
            this.form = res.data.data;
            this.form.image = null;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
    onSubmit() {
      this.$http
        .patch("setting/" + this.$route.params.id, this.form)
        .then((res) => {
          if (res.data.status == 1) {
            this.$router.push({
              name: "SettingList",
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
